export default "__VITE_ASSET__DuhYkAUJ__"